<template>
  <div class="user-workspaces">
    <Table
      v-if="user.collaborationWorkspaces && user.collaborationWorkspaces.length"
      title="Workspaces where user is a member"
      :rows="user.collaborationWorkspaces"
      :fields="fields"
      @rowClick="onRowClick"
      collapsed
    />
  </div>
</template>

<script>
import Table from '@/components/Table'

export default {
  name: 'UserCollaborationWorkspaces',
  components: {
    Table,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      fields: {
        title: { title: 'Title' },
        role: { title: 'Role' },
      },
    }
  },
  methods: {
    onRowClick(workspace) {
      this.$emit('rowClick', workspace)
    },
  },
}
</script>
